import { PopUtils } from '../../framework/components/pop/pop-utils';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizPopUp, PopUpManager } from '@wizeoo/akm-component-lib';
import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';

/**
 * PopUp de création d'un template de widgets
 */
@Component({
  templateUrl: 'color-picker.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPickerPop extends WizBasePopUp {
  /** Méthode statique de création/affichage d'un color picker */
  public static show(
    pRelatedElement: HTMLElement,
    pEventTarget: EventTarget,
    pColor: string,
    pCallback: (pTarget: EventTarget, pColorResult: string) => void
  ) {
    const pop: WizPopUp = new WizPopUp(
      ColorPickerPop,
      false,
      false,
      null,
      '230px',
      '315px',
      [pEventTarget, pColor, pCallback],
      'section-container'
    );
    const pos: DOMRect = pRelatedElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, pop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    pop.customPosition = targetPosition;

    if (PopUpManager.exist(pop)) {
      // suppression de l'instance existante
      pop.hide();
    }
    pop.show();
  }

  public pickedColor = '#FFFFFFFF';
  public source: any;

  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef) {
    super();
  }

  /** click sur le bouton OK */
  public setColor(value: string): void {
    this.hide();
  }

  show() {
    this.pickedColor = this.datas[1];
    // console.log('pickColor', this.pickedColor);
    this.source = this.datas[0];
    this.callback = this.datas[2];
    this.cdref.markForCheck();
  }

  hide(): void {
    this.callback(this.source, this.pickedColor);
    super.hide();
  }
}
